import React, { useEffect, useState, useRef, useContext } from 'react';
import useOutsideClick from '../../../hooks/useClickOutside';

const DropdownFacetWithCustomOptions = props => {
  const {
    showNumberSelected = false,
    showSecondaryLabel = true,
    options = [
      {
        value: 'us',
        label: 'US',
        placeholder: 'Enter City, State or Zip',
        source: 'Production US - English'
      },
      {
        value: 'ca',
        label: 'CA',
        default: 'true',
        placeholder: 'Enter City, Province or Postal Code',
        source: 'Production CA'
      }
    ],
    facet = {
      id: 'facet-id',
      title: 'Facet Title',
      isSingleSelect: false
    },
    type = 'with-checkbox-and-results',
    immediateAction = false,
    onFacetChange = null,
    values = [],
    onResetFacet,
  } = props;

  const [selectedValues, setSelectedValues] = useState(values);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (onFacetChange && expanded) {
      onFacetChange(facet, selectedValues, immediateAction);
    }
  }, [selectedValues]);

  useEffect(() => {
    if (onResetFacet) {
      setSelectedValues([]);
    }
  }, [onResetFacet]);

  const handleFacetClick = (value) => {
    if (facet.isSingleSelect) {
      if (selectedValues.includes(value)) {
        setSelectedValues([]);
      } else {
        setSelectedValues([value]);
      }
    } else {
      if (selectedValues.includes(value)) {
        setSelectedValues(selectedValues.filter(item => item !== value));
      } else {
        setSelectedValues([...selectedValues, value]);
      }
    }
  };

  const ref = useOutsideClick(() => {
    setExpanded(false);
  });

  const checkSelected = value => {
    return selectedValues.includes(value);
  };

  const renderFacet = value => {
    //type is one of
    //'with-checkbox-and-results'
    //'with-results'
    //'with-checkbox'
    //'with-underline-on-select'
    return (
      <div className={`listing-row-facet listing-row-facet--${type} ${checkSelected(value) || value.state === 'selected' ? 'listing-row-facet--selected' : ''}`} onClick={() => handleFacetClick(value)}>
        <input
          type="checkbox"
          className="listing-row-facet__checkbox-input"
          value={value}
          aria-label={value.value}
          tabIndex="-1"
          defaultChecked={checkSelected(value)}
        />
        <button className="listing-row-facet__checkbox-button" aria-label={value.value} aria-checked={checkSelected(value)}></button>
        <label className="listing-row-facet__label" title={value.label} aria-hidden="false">{value.label}</label>
      </div>
    );
  };

  return (
    <div className="field dropdown-module" ref={ref}>
      <div className="field__input-label-wrapper">
        <div className="field__select-arrow-wrapper">
          <div className="dropdown ">
            <svg width="18" height="11" role="presentation">
              <use xlinkHref="#arrow-down"></use>
            </svg>
            <select aria-label="Dynamic Facet" className="field__select" tabIndex="-1">
              <option value disabled>{facet.title}</option>
              {options.length > 0 &&
                options.map(value => (<option key={value.value} value={value.value}>{value.value}</option>))
              }
            </select>
            <button aria-label={facet.title} className="dropdown__trigger field__select" type="button" aria-expanded={expanded}  onClick={() => setExpanded(!expanded)}>
              <span>{facet.title}</span>
              {facet.isSingleSelect && selectedValues.length > 0 && showSecondaryLabel && (
                <span className="dropdown-secondary-label">
                  {selectedValues.find(x => x === selectedValues[selectedValues.length - 1] ).label}
                </span>
              )}
            </button>
            <div className="dropdown__list">
              <ul className="coveo-dynamic-facet-values">
                {options.length > 0 &&
                  options.map(value => (<li className="dropdown-facet__value" key={value.value}>{renderFacet(value)}</li>))
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropdownFacetWithCustomOptions;
